export default __webpack_public_path__ + "static/media/barlow-condensed.light.937f42d7.ttf";